<div *ngIf="meeting$ | async as meeting; else loading" class="meeting-container">
  <lfx-meeting-summary-header [meeting]="meeting"></lfx-meeting-summary-header>
  <lfx-meeting-summary-form [meeting]="meeting" [form]="form" (refresh)="refresh()"></lfx-meeting-summary-form>
  <div class="flex flex-col items-center gap-3">
    <p class="text-xs font-opensans">Powered by</p>
    <img class="max-h-8 w-full" [src]="logoURL" />
  </div>
  <lfx-footer cookie-tracking="true"></lfx-footer>
</div>
<ng-template #loading>
  <div class="meeting-container">
    <p-skeleton height="100%" width="100%"></p-skeleton>
  </div>
</ng-template>
